import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityListReport  {
    _originalTypeClassName = "zERP.BO.TransactionEntityListReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityListReport.translate = translateService;
}
this.TransactionEntities = [];
this.DateFrom = null;
this.DateTo = null;
this.TransactionEntityListReportKey = null;
this._key = this.TransactionEntityListReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
TransactionEntities:any;
TotalReport:any;
private _TransactionEntityListReportKey:any;
get TransactionEntityListReportKey(): any {
    return this._TransactionEntityListReportKey;
  }
set TransactionEntityListReportKey(value: any) {
    this._TransactionEntityListReportKey = value;
    this._key = value;
  }
static setTransactionEntities = ($this, items) => {
                if (items == null) items = [];
                if ($this.TransactionEntities == null) $this.TransactionEntities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TransactionEntities.length > 0) {
                    Domain.TransactionEntityListReport.removeTransactionEntities($this, $this.TransactionEntities[0]);
                }

                Domain.TransactionEntityListReport.addManyTransactionEntities($this, copyItems);
            }
static addManyTransactionEntities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionEntityListReport.addTransactionEntities($this, items[i]);
                }
            }
static addTransactionEntities = ($this, item) => {
                if ($this.TransactionEntities == null) $this.TransactionEntities = [];
                if (item == null || $this.TransactionEntities.indexOf(item) > -1) return;
                $this.TransactionEntities.push(item);
}
static addRangeTransactionEntities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionEntityListReport.addTransactionEntities($this, item));
            }
static removeTransactionEntities = ($this, item) => {
                if ($this == null || $this.TransactionEntities == null || $this.TransactionEntities.indexOf(item) === -1) return;
                var _index = $this.TransactionEntities.indexOf(item);
                $this.TransactionEntities.splice(_index, 1);
}
static clearTransactionEntities = ($this) => { $this.TransactionEntities = null; }
static setTotalReport = ($this, value) => {
var oldValue = $this.TotalReport;
$this.TotalReport = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityListReportKey == null || $this.TransactionEntityListReportKey == 0;
            }


}